/** @jsxImportSource @emotion/react */
import { Tag } from "primereact/tag";

// Tag "Periódica" para ítems de facturación cuyo origen es una refacturación
// automática (facturación recurrente).
export default function TagRefacturacion() {
  return (
    <Tag value="Periódica" severity="warning" css={{ marginLeft: "0.5em" }} />
  );
}
